<template>
  <div class="userInfo">
    <el-form :model="form" :rules="rules" ref="ruleForm" label-position="left" label-width="150px" class="userFrom" v-loading="loading">
      <el-row type="flex" justify="space-around">
        <el-col :span="9">
          <el-form-item label="最终客户单位名称：" prop="finalCustomerName">
            <el-input v-model="form.finalCustomerName" maxlength="100" class="itemClass" placeholder="请输入最终客户单位名称"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="9">
          <el-form-item label="申请单位名称：" prop="companyName">
            <el-input v-model="form.companyName" maxlength="100" class="itemClass" placeholder="请输入申请单位名称"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row type="flex" justify="space-around">
        <el-col :span="9">
          <el-form-item label="申请联系人姓名：" prop="userName">
            <el-input v-model="form.userName" maxlength="100" class="itemClass" placeholder="请输入申请联系人姓名"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="9">
          <el-form-item label="申请联系人电话：" prop="phone">
            <el-input v-model="form.phone" class="itemClass" placeholder="请输入申请联系人电话" maxlength="20"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row type="flex" justify="space-around">
        <el-col :span="9">
          <el-form-item label="申请联系人E-mail：" prop="email" class="email">
            <el-tooltip class="item" effect="dark" :arrowOffset="17" content="此邮箱用户接收激活结果，请确认邮箱地址有效" placement="top-start">
              <el-input v-model="form.email" maxlength="100" class="itemClass" placeholder="请输入申请联系人E-mail"></el-input>
            </el-tooltip>
          </el-form-item>
        </el-col>
        <el-col :span="9">
          <el-form-item label="申请联系人邮编：" prop="postCode">
            <el-input v-model="form.postCode" maxlength="10" class="itemClass" placeholder="请输入申请联系人邮编"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row type="flex" justify="space-around">
        <el-col :span="9">
          <el-form-item label="申请联系人地址：" prop="address">
            <el-input v-model="form.address" maxlength="300" class="itemClass" placeholder="请输入联系人地址"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="9">
          <el-form-item label="项目名称：" prop="projectName">
            <el-input v-model="form.projectName" maxlength="100" class="itemClass" placeholder="请输入项目名称"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import { checkForm } from "~/util/commonUtil";
import zgyLicenseReq from "~/request/zgyLicenseReq";
export default {
  data(){
    return{
      loading:false,
      form:{
        finalCustomerName: '',
        companyName: '',
        userName: '',
        phone: '',
        email: '',
        postCode: '',
        address: '',
        projectName: '',
      },
      rules:{
        finalCustomerName:[
          { required: true, message: '请输入最终客户单位名称', trigger: ['blur', 'change'] }
        ],
        companyName:[
          { required: true, message: '请输入申请单位名称', trigger: ['blur', 'change'] }
        ],
        userName:[
          { required: true, message: '请输入申请联系人姓名', trigger: ['blur', 'change'] }
        ],
        phone:[
          { required: true, message: '请输入申请联系人电话', trigger: ['blur', 'change'] },
          { pattern: /^[0-9-()]{1,20}$/, message: '请输入正确的联系人电话', trigger: ['blur', 'change'] }
        ],
        email:[
          { required: true, message: '请输入申请联系人E-mail', trigger: ['blur', 'change'] },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
        ],
        postCode:[
          { pattern: /^[0-9]*$/, message: '请输入正确的邮编', trigger: ['blur', 'change'] }
        ],
      },
    }
  },
  created(){
    //查询用户信息
    this.loading = true;
    const processNo = sessionStorage.getItem('processNo');
    zgyLicenseReq.getUser(processNo).then(res=>{
    this.loading = false;
      if(res.status){
        let resKeys = Object.keys(res.res);
        let formKeys = Object.keys(this.form);
        resKeys.forEach(label => {
          if(formKeys.includes(label)){
            this.form[label] = res.res[label];
          }       
        })
      }
    })
  },
  methods:{
    seeHelp(){
      window.open(`${location.origin}/document/license_activation_step3.html`);
    },
    getVail(){
      return checkForm('ruleForm', this);
    },
    getData(){
      return this.form;
    }
  }
}
</script>
<style lang="less" scoped>
.userInfo{
  margin-top:20px;
  .operateClass{
    text-align: right;
    margin-bottom: 16px;   
  }
  .userFrom{
    .el-form-item{
      margin-bottom: 32px;
    }
    .email{
      margin-bottom: 15px;
      .tip{
        font-size: 10px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        height: 17px;
        line-height: 17px;
      }
    }
  }
  /deep/ .el-form-item__label,.el-input__inner {
    color: #333333 !important;
  }
}
</style>